// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import calendarIcon from "@/assets/icons/calendar.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type CalendarIconProps = Omit<IconProps, "name">;

export function CalendarIcon(props: CalendarIconProps): React.ReactNode {
  return <Icon name={calendarIcon} {...props} />;
}
